import { useState } from 'react'
import { Lightbulb, ChevronDown } from 'lucide-react'

interface PhotoTipsBannerProps {
  tips: string[]
}

export function PhotoTipsBanner({ tips }: PhotoTipsBannerProps) {
  const [expanded, setExpanded] = useState(() => {
    try {
      return sessionStorage.getItem('iris-tips-collapsed') !== 'true'
    } catch {
      return true
    }
  })

  if (tips.length === 0) return null

  const toggle = () => {
    const next = !expanded
    setExpanded(next)
    try {
      sessionStorage.setItem('iris-tips-collapsed', next ? 'false' : 'true')
    } catch {
      // sessionStorage unavailable in some WebViews
    }
  }

  return (
    <div className="mb-6 overflow-hidden rounded-lg border-[0.5px] border-[var(--gold-border)] bg-[var(--gold-bg)]">
      <button
        type="button"
        onClick={toggle}
        className="flex w-full items-center gap-2.5 px-4 py-3"
      >
        <Lightbulb size={14} className="flex-none text-[var(--gold-ink)]" />
        <span className="flex-1 text-left text-[12px] font-medium text-[var(--gold-ink)]">
          Photo tips
        </span>
        <ChevronDown
          size={14}
          className={`flex-none text-[var(--gold-ink)] transition-transform duration-200 ${
            expanded ? 'rotate-180' : ''
          }`}
        />
      </button>

      <div
        className={`grid transition-all duration-200 ease-out ${
          expanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        }`}
      >
        <div className="overflow-hidden">
          <ul className="space-y-1.5 px-4 pb-3">
            {tips.map((tip, i) => (
              <li key={i} className="flex gap-2 text-[12px] leading-relaxed text-[var(--gold-ink)]">
                <span className="mt-1.5 h-1 w-1 flex-none rounded-full bg-[var(--gold-ink)] opacity-40" />
                {tip}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
